/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Allowed range for max participants
 * @export
 * @interface SurfaceLeaderboardConfigMaxParticipantsRange
 */
export interface SurfaceLeaderboardConfigMaxParticipantsRange {
    /**
     * 
     * @type {number}
     * @memberof SurfaceLeaderboardConfigMaxParticipantsRange
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceLeaderboardConfigMaxParticipantsRange
     */
    max?: number;
}

/**
 * Check if a given object implements the SurfaceLeaderboardConfigMaxParticipantsRange interface.
 */
export function instanceOfSurfaceLeaderboardConfigMaxParticipantsRange(value: object): value is SurfaceLeaderboardConfigMaxParticipantsRange {
    return true;
}

export function SurfaceLeaderboardConfigMaxParticipantsRangeFromJSON(json: any): SurfaceLeaderboardConfigMaxParticipantsRange {
    return SurfaceLeaderboardConfigMaxParticipantsRangeFromJSONTyped(json, false);
}

export function SurfaceLeaderboardConfigMaxParticipantsRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceLeaderboardConfigMaxParticipantsRange {
    if (json == null) {
        return json;
    }
    return {
        
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
    };
}

export function SurfaceLeaderboardConfigMaxParticipantsRangeToJSON(json: any): SurfaceLeaderboardConfigMaxParticipantsRange {
    return SurfaceLeaderboardConfigMaxParticipantsRangeToJSONTyped(json, false);
}

export function SurfaceLeaderboardConfigMaxParticipantsRangeToJSONTyped(value?: SurfaceLeaderboardConfigMaxParticipantsRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min': value['min'],
        'max': value['max'],
    };
}

